import { CRON_EXECUTED } from './types';

export default {
  async [CRON_EXECUTED]({ commit }, payload) {
    commit(CRON_EXECUTED, payload);
  }
};
